import styled from 'styled-components';

import {H1} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {RouterLink as BaseRouterLink} from 'src/components/primitives';
import {EdnaImage as BaseEdnaImage} from 'src/images';

const Title = styled(H1)`
  text-align: center;
`;

const RouterLink = styled(BaseRouterLink)`
  display: block;
  text-align: center;
  margin-top: ${({theme}) => theme.spacing.s5};
`;

const TimerLayout = styled.span`
  ${mixins.wh('40px', '17px')}
  position: relative;
  display: inline-block;
  margin: 0 ${({theme}) => theme.spacing.s1};
  vertical-align: baseline;
`;

const MAX_WIDTH = 940;

const Wrapper = styled.div`
  ${mixins.stack({direction: 'COLUMN'})};
  flex: 1;
  width: 100%;
  max-width: ${MAX_WIDTH}px;
  margin: ${({theme}) => `${theme.spacing.s8} auto`};

  ${mixins.media.laptop`
    ${mixins.flexAlign('center')}
    flex-direction: row;
    padding-left: calc(100vw - 100%);
  `}
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: space-between;
  width: 100%;
  max-width: 352px;
  margin: 0 auto;
  padding: 0 ${({theme}) => theme.spacing.s4};
`;

const EdnaImage = styled(BaseEdnaImage)`
  ${mixins.wh('100px')}
  margin: 0 auto ${({theme}) => theme.spacing.s6};

  ${mixins.media.laptop`
    ${mixins.wh('400px')}
    margin: 0 52px;
  `}
`;

const EdnaLogo = styled.div`
  ${mixins.flexAlign('center', 'center')}
  gap: ${({theme}) => theme.spacing.s2};
  color: ${({theme}) => theme.palette.black};

  margin-bottom: ${({theme}) => theme.spacing.s2};
`;

export {TimerLayout, RouterLink, Title, EdnaImage, Form, Wrapper, EdnaLogo};
